import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Placeholder, PlaceholderLine, PlaceholderMedia } from '@/src/elements/placeholder'
import { TEST_ID } from '@/src/general/constants/testId'

export const WatchmanSummaryPlaceholder = (): ReactNode => (
  <Placeholder testID={TEST_ID.WATCHMAN.SUMMARY.PLACEHOLDER} className="flex-col">
    <View className="flex-row items-center">
      <PlaceholderMedia />
      <PlaceholderLine className="ml-2 max-w-36" />
    </View>
    <PlaceholderLine className="mt-2" />
  </Placeholder>
)
